// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"63":"e230a8cd","107":"ad39de27","408":"04bb4f12","452":"ae23498e","620":"d2adbe5c","807":"c1f9ec0a"}[chunkId] + ".css";
};